export const APPLY_BOT_TYPES = {
  APPLY: 'apply',
  APPLY_FEW: 'apply_few',
  APPLY_ONE: 'apply_one',
  NO_APPLY: 'no_apply',
  APPLY_V2: 'apply_v2',
} as const;
